import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="img/hero.avif"
          alt="Conference Room"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/65" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-cream via-transparent to-black/30" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center mt-12">
        <div data-aos="fade-down" className="inline-block mb-6 px-5 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
          <span className="text-white text-xs font-semibold uppercase tracking-widest">
            Management & Market Research
          </span>
        </div>

        <h1
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-4xl sm:text-6xl md:text-7xl font-extrabold text-white leading-tight mb-8 tracking-tight"
        >
          Maximize Your <br />
          <span className="text-brand-orange font-extrabold">Business Potential</span>
        </h1>

        <p
          data-aos="fade-up"
          data-aos-delay="200"
          className="text-lg md:text-xl text-gray-200 max-w-3xl mx-auto font-normal leading-relaxed mb-12"
        >
          Capilano Consulting empowers organizations through premier management consulting and comprehensive market research. We position your business for sustainable growth in competitive markets.
        </p>

        <div
          data-aos="fade-up"
          data-aos-delay="300"
          className="flex flex-col sm:flex-row gap-5 justify-center items-center"
        >
          <Link to="/contact" className="btn-primary px-10 py-4 text-base">
            Consult With Us
          </Link>
          <Link to="/services" className="btn-outline px-10 py-4 text-base">
            Explore Services
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;